import { render, staticRenderFns } from "./ObjectivesEditor.vue?vue&type=template&id=1c9618de"
import script from "./ObjectivesEditor.vue?vue&type=script&lang=js"
export * from "./ObjectivesEditor.vue?vue&type=script&lang=js"
import style0 from "./ObjectivesEditor.vue?vue&type=style&index=0&id=1c9618de&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports